import router from "@/router";
import store from "@/state/store";
import isEqual from "lodash/isEqual";

/**
 * 🔒 Function which hides a certain number and substitutes it with asterisks
 */
export function censorDataIfNeeded(value: any, limitToUrl?: string) {
  if (
    store.state.userPreferences.censorSensitiveData && (
      limitToUrl == undefined ||
      isEqual(limitToUrl, router.currentRoute.path))
  ) {
    if (value.toString().charAt(0) === "$") {
      return "$***";
    }
    if (value.toString().startsWith("+$") || value.toString().startsWith("-$")) {
      return value[0] + "$***";
    }
    return "***";
  }
  return value;
}
